import React, { Component } from "react";
import moment from 'moment';
import { ajax, unparam } from "utils/common";
import { Icon, Table, Popover, DatePicker, Button, Modal, Input, Tree, Spin, Tooltip } from 'antd';
import "./index.less";

class App extends Component {
    state = {
        initData: {},
        queryAiLeftTimes: {},
        queryFlowList: [],
        queryPostsList: [],
        searchList: null,
        selectData: {},
        paramData: {},
        paramDataList: {},
        visible: {},
        isSpin: {}
    }

    urlParam = this.props.location.search && unparam(this.props.location.search).corpCode ? {corpCode: unparam(this.props.location.search).corpCode} : {};

    formatSeconds = (value) => {
        let secondTime = parseInt(value);// 秒
        let minuteTime = 0;// 分
        let hourTime = 0;// 小时
        if(secondTime > 60) {//如果秒数大于60，将秒数转换成整数
            //获取分钟，除以60取整数，得到整数分钟
            minuteTime = parseInt(secondTime / 60);
            //获取秒数，秒数取佘，得到整数秒数
            secondTime = parseInt(secondTime % 60);
            //如果分钟大于60，将分钟转换成小时
            if(minuteTime > 60) {
                //获取小时，获取分钟除以60，得到整数小时
                hourTime = parseInt(minuteTime / 60);
                //获取小时后取佘的分，获取分钟除以60取佘的分
                minuteTime = parseInt(minuteTime % 60);
            }
        }
        let result = "" + parseInt(secondTime) + "秒";

        if(minuteTime > 0) {
            result = "" + parseInt(minuteTime) + "分" + result;
        }
        if(hourTime > 0) {
            result = "" + parseInt(hourTime) + "小时" + result;
        }
        return result;
    }

    getInitData = () => {
        ajax({
            url: "/api/human/querySummary",
            data: this.urlParam
        }).then(res => {
            let data = res.data;
            if(data && data.fileSize !== undefined) {
                data.fileSize = (data.fileSize / 1024 / 1024).toFixed(2);
            }
            if(data && data.duration !== undefined) {
                data.duration = this.formatSeconds(data.duration);
            }
            this.setState({
                initData: data
            });
        })
    }

    getQueryAiLeftTimes = () => {
        ajax({
            url: "/api/human/queryAiLeftTimes",
            data: this.urlParam
        }).then(res => {
            this.setState({
                queryAiLeftTimes: res.data
            });
        })
    }

    getQueryFlow = () => {
        let newIsSpin = this.state.isSpin;
        newIsSpin['table'] = true;
        this.setState({
            isSpin: newIsSpin
        }, () => {
            ajax({
                url: "/api/human/queryFlow",
                method: 'post',
                contentType: 'application/json',
                data: {...this.state.paramData, ...this.urlParam}
            }).then(res => {
                let list = res.data;
                for(let [index, value] of list.entries()) {
                    value.key = index;
                    if(value.fileSize !== undefined) {
                        value.fileSize = (value.fileSize / 1024 / 1024).toFixed(2);
                    }
                }
                newIsSpin['table'] = false;
                this.setState({
                    isSpin: newIsSpin,
                    queryFlowList: list
                });
            })
        });
    }

    getQueryPosts = (obj = {}, callback) => {
        let newIsSpin = this.state.isSpin;
        newIsSpin['posts'] = true;
        this.setState({
            isSpin: newIsSpin
        },() => {
            ajax({
                url: "/api/human/queryPosts",
                data: {...obj, ...this.urlParam}
            }).then(res => {
                newIsSpin['posts'] = false;
                this.setState({
                    isSpin: newIsSpin
                });
                callback && callback(res);
            })
        });
    }

    onChange = (value) => {
        this.getQueryPosts({param: value}, (res) => {
            if(value) {
                this.setState({
                    searchList: res.data && res.data.length > 0 ? res.data : []
                });
            } else {
                this.setState({
                    searchList: null
                });
            }
        });
    }

    changePicker =(data, dateString, type) => {
        let newSelectData = this.state.selectData;
        newSelectData[type] = dateString;
        this.setState({
            selectData: newSelectData
        });
    }

    selectData = (type) => {
        let newParamData = this.state.paramData, newParamDataList = this.state.paramDataList, selectData = this.state.selectData;
        if(type === 'time') {
            if(selectData.uploadedAtStart > selectData.uploadedAtEnd) {
                Modal.warning({
                    title: '提示',
                    content: '开始时间不能大于结束时间！',
                });
                return;
            }
            newParamData['uploadedAtStart'] = selectData.uploadedAtStart;
            newParamData['uploadedAtEnd'] = selectData.uploadedAtEnd;
            if(selectData.uploadedAtStart && selectData.uploadedAtEnd) {
                newParamDataList.time = `${selectData.uploadedAtStart}~${selectData.uploadedAtEnd}`;
            } else if(selectData.uploadedAtStart) {
                newParamDataList.time = selectData.uploadedAtStart;
            } else if(selectData.uploadedAtEnd) {
                newParamDataList.time = selectData.uploadedAtEnd;
            } else {
                delete newParamDataList.time;
            }
        } else if(type === 'posts') {
            newParamData[type] = JSON.parse(JSON.stringify(selectData[type]));
            newParamDataList[type] = JSON.parse(JSON.stringify(selectData[type]));
        } else {
            newParamData[type] = selectData[type];
            newParamDataList[type] = selectData[type];
        }
        this.setState({
            paramData: newParamData,
            paramDataList: newParamDataList
        }, () => {
            this.handleVisibleChange(false, type);
        });
    }

    handleVisibleChange = (visible, type) => {
        let newVisible = this.state.visible;
        newVisible[type] = visible;
        this.setState({
            visible : newVisible
        });
    }

    clearSelectData = () => {
        this.setState({
            selectData: {},
            paramData: {},
            paramDataList: {}
        });
    }

    closeSelect = (type) => {
        let newParamData = this.state.paramData, newParamDataList = this.state.paramDataList, newSelectData = this.state.selectData;
        if(type === 'time') {
            delete newParamData['uploadedAtStart'];
            delete newParamData['uploadedAtEnd'];
            delete newSelectData['uploadedAtStart'];
            delete newSelectData['uploadedAtEnd'];
            delete newParamDataList['time'];
        } else {
            delete newParamData[type];
            delete newSelectData[type];
            delete newParamDataList[type];
        }
        this.setState({
            selectData: newSelectData,
            paramData: newParamData,
            paramDataList: newParamDataList
        });
    }

    onSelect = (selectedKeys) => {
        let newSelectData = this.state.selectData;
        newSelectData['posts'] = selectedKeys;
        this.setState({
            selectData: newSelectData
        });
    }

    delSelect = (index) => {
        let newSelectData = this.state.selectData;
        newSelectData['posts'].splice(index,1);
        this.setState({
            selectData: newSelectData
        });
    }

    clearBtn = () => {
        let newSelectData = this.state.selectData;
        delete newSelectData['posts'];
        this.setState({
            selectData: newSelectData
        });
    }

    comeBackData = () => {
        let newSelectData = this.state.selectData;
        if(this.state.paramDataList.posts) {
            newSelectData['posts'] = JSON.parse(JSON.stringify(this.state.paramDataList))['posts'];
        } else {
            delete newSelectData['posts'];
        }
        this.setState({
            selectData: newSelectData
        });
    }

    componentDidMount() {
        this.getInitData();
        this.getQueryAiLeftTimes();
        this.getQueryFlow();
        this.getQueryPosts({},(res) => {
            this.setState({
                queryPostsList: res.data
            });
        });
    }

    render() {
        const { queryFlowList, initData, queryAiLeftTimes, visible, paramDataList, selectData, queryPostsList, searchList, isSpin } = this.state;
        const columns = [
            {
                title: '视频名称',
                dataIndex: 'fileName',
                render: text => <span title={text} className="textList">{text}</span>
            }, {
                title: '视频大小（MB）',
                dataIndex: 'fileSize',
                render: text => <span title={text} className="textList">{text}</span>
            }, {
                title: '视频时长（S）',
                dataIndex: 'fileDuration',
                render: text => <span title={text} className="textList">{text}</span>
            }, {
                title: '候选人姓名',
                dataIndex: 'userName',
                render: text => <span title={text} className="textList">{text}</span>
            }, {
                title: '候选人手机',
                dataIndex: 'phone',
                render: text => <span title={text} className="textList">{text}</span>
            }, {
                title: '应聘职位',
                dataIndex: 'postName',
                render: text => <span title={text} className="textList">{text}</span>
            }, {
                title: '报告生成状态',
                dataIndex: 'processingStatus',
                render: text => <span title={text} className="textList">{text}</span>
            }, {
                title: '报告生成日期',
                dataIndex: 'uploadedAt',
                render: text => <span title={text ? moment(text).format("YYYY-MM-DD") : ''} className="textList">{text ? moment(text).format("YYYY-MM-DD") : ''}</span>
            }
        ];
        return (
            <div className="report-flow-wrap">
                <div className="clearfix mb20">
                    <div className="fl">
                        <h4 className="wt-c-tit wtspe-theme-border"><span className="ml5"> 资金动态 </span></h4>
                    </div>
                </div>
                <ul className="money-status">
                    <li><span></span>{initData.total}个 <p>已用份额 <Tooltip placement="right" title="包含已生成报告的份数和已安排单向但未实际生成报告预扣的份数">
                        <Icon type="exclamation-circle" />
                    </Tooltip></p></li>
                    <li><span></span>{queryAiLeftTimes.leftNum}个 <p>剩余可用份额</p></li>
                    <li><span></span>{initData.fileSize}MB <p>总视频文件大小</p></li>
                    <li>{initData.duration} <p>总视频文件时长</p></li>
                </ul>
                <div className="wt-search-container">
                    <div className="widget_box">
                        <span>筛选条件：</span>
                        <div className="condition-container">
                            <div className="widget">
                                <Popover visible={visible['time']} placement="bottom" content={(
                                    <div className="widget_select_box">
                                        <DatePicker value={selectData['uploadedAtStart'] ? moment(selectData['uploadedAtStart'], 'YYYY-MM-DD') : null} onChange={(data, dateString) => this.changePicker(data, dateString, 'uploadedAtStart')} placeholder="开始日期" />
                                        <br />---<br />
                                        <DatePicker value={selectData['uploadedAtEnd'] ? moment(selectData['uploadedAtEnd'], 'YYYY-MM-DD') : null} onChange={(data, dateString) => this.changePicker(data, dateString, 'uploadedAtEnd')} placeholder="结束日期" /><br />
                                        <Button type="primary" onClick={() => this.selectData('time')}>确定</Button>
                                    </div>
                                )} onVisibleChange={(visible) => this.handleVisibleChange(visible, 'time')} trigger="click">
                                    <span className={paramDataList.time ? "wtspe-theme-word wtspe-theme-color" : "wtspe-theme-word"}>报告生成日期</span>
                                </Popover>
                            </div>
                            <div className="widget">
                                <Popover visible={visible['userName']} placement="bottom" content={(
                                    <div className="widget_select_box">
                                        <Input value={selectData['userName']} placeholder="请输入，按回车确认" onChange={(e) => this.changePicker(null, e.target.value, 'userName')} onPressEnter={() => this.selectData('userName')} /><br />
                                        <Button type="primary" onClick={() => this.selectData('userName')}>确定</Button>
                                    </div>
                                )} onVisibleChange={(visible) => this.handleVisibleChange(visible, 'userName')} trigger="click">
                                    <span className={paramDataList.userName ? "wtspe-theme-word wtspe-theme-color" : "wtspe-theme-word"}>候选人姓名</span>
                                </Popover>
                            </div>
                            <div className="widget">
                                <Popover visible={visible['phone']} placement="bottom" content={(
                                    <div className="widget_select_box">
                                        <Input value={selectData['phone']} placeholder="请输入，按回车确认" onChange={(e) => this.changePicker(null, e.target.value, 'phone')} onPressEnter={() => this.selectData('phone')} /><br />
                                        <Button type="primary" onClick={() => this.selectData('phone')}>确定</Button>
                                    </div>
                                )} onVisibleChange={(visible) => this.handleVisibleChange(visible, 'phone')} trigger="click">
                                    <span className={paramDataList.phone ? "wtspe-theme-word wtspe-theme-color" : "wtspe-theme-word"}>候选人手机</span>
                                </Popover>
                            </div>
                            <div className="widget">
                                <span className={paramDataList.posts ? "wtspe-theme-word wtspe-theme-color" : "wtspe-theme-word"} onClick={() => this.handleVisibleChange(true, 'posts')}>应聘职位</span>
                            </div>
                            <Modal destroyOnClose visible={visible['posts']} className="selectModel" width={580} maskClosable={false}
                                   title="机构/职位查询--请选择要查询的职位"
                                   onCancel={() => {
                                       this.handleVisibleChange(false, 'posts');
                                       this.comeBackData();
                                   }}
                                   footer={[
                                       <Button key="back" type="primary" onClick={() => this.clearBtn()}>清空</Button>,
                                       <Button key="submit" type="primary" onClick={() => this.selectData('posts')}>提交</Button>
                                   ]}>
                                <div className="choose-post">
                                    <div className="process-tree-box">
                                        <div className="process-tree">
                                            <Input.Search style={{ marginBottom: 8 }}
                                                placeholder="输入拼音或关键字"
                                                onSearch={this.onChange} />
                                            <Spin spinning={isSpin['posts']}>
                                                <Tree selectable={false} checkable onCheck={this.onSelect}
                                                      checkedKeys={selectData['posts'] ? JSON.parse(JSON.stringify(selectData['posts'])) : null}>
                                                    {queryPostsList && queryPostsList.length > 0 && queryPostsList.map((item, index) => {
                                                        return <Tree.TreeNode style={{display: (!searchList || searchList.includes(item)) ? 'block' : 'none'}} key={item} title={item} />
                                                    })}
                                                </Tree>
                                            </Spin>
                                        </div>
                                    </div>
                                    <div className="process-select-box">
                                        <div className="select-tit">已选择列表</div>
                                        <div className="select-list">
                                            <ul>
                                                {selectData['posts'] && selectData['posts'].length > 0 && selectData['posts'].map((item,index) => {
                                                    return <li key={index}><i title={item}>{item}</i><span onClick={() => this.delSelect(index)}></span></li>
                                                })}
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </Modal>
                        </div>
                    </div>
                    <div className="selected_box">
                        <div className="selected-condition-container">
                            {Object.keys(paramDataList).map(key => {
                                return <div key={key} className="selected-condition" title={paramDataList[key]}>
                                    <span>{paramDataList[key]}</span>
                                    <Icon className="close" onClick={() => this.closeSelect(key)} type="close" />
                                </div>
                            })}
                            <div className="btns_box">
                                <div className="wt-button-5" onClick={() => this.getQueryFlow()}>搜索</div>
                                <div className="wt-button-link" onClick={() => this.clearSelectData()}>清空已选条件</div>
                            </div>
                        </div>
                    </div>
                </div>
                <Table className="reportTable" loading={isSpin['table']} rowKey={record => record.key}  columns={columns} dataSource={queryFlowList} pagination={{
                    showSizeChanger: true,
                    showTotal: (total) => {return `（共${total}条）`;}
                }} />
            </div>
        );
    }
}

export default App;